import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { Collapse, Tag, Row, Tooltip } from 'antd';
import { MinusOutlined, PlusOutlined, CloseCircleOutlined, StarOutlined } from '@ant-design/icons';
import { getFeaturesList, getFilteredFeaturesList } from '../../utils/featuresUtils';

const Features = ({ planType, currentUserPlan, newPlan, isDowngrade, isUpgrade }) => {
  let lostFeatures = [];
  const intl = useIntl();

  let filteredList = getFilteredFeaturesList(intl, planType);

  if (isDowngrade && currentUserPlan && newPlan) {
    const filterCallback =
      currentUserPlan?.planType === 'ace' && newPlan?.planType === 'starter'
        ? (f) => f.planType !== newPlan?.planType
        : (f) => f.planType === currentUserPlan?.planType;
    lostFeatures = getFeaturesList(intl)
      .filter(filterCallback)
      .map((f) => {
        return {
          ...f,
          tag: (
            <Tooltip
              title={
                <FormattedMessage defaultMessage="You will not have access to this feature anymore" />
              }
            >
              <Tag color="error" icon={<CloseCircleOutlined />}>
                <FormattedMessage defaultMessage="Lost feature" />
              </Tag>
            </Tooltip>
          ),
        };
      });

    filteredList = filteredList.filter((feature) => {
      return feature.planType === newPlan?.planType;
    });
  }

  if (isUpgrade && newPlan) {
    filteredList = filteredList
      .map((f) => {
        return f.planType === newPlan?.planType
          ? {
              ...f,
              tag: (
                <Tag icon={<StarOutlined />}>
                  <FormattedMessage defaultMessage="New" />
                </Tag>
              ),
            }
          : f;
      })
      .sort((a, b) => {
        if (a.tag && !b.tag) {
          return -1;
        }
        if (!a.tag && b.tag) {
          return 1;
        }
        return 0;
      });
  }

  return (
    <Collapse
      ghost
      accordion
      expandIcon={({ isActive }) => (isActive ? <MinusOutlined /> : <PlusOutlined />)}
      className="plan-collapse"
    >
      {lostFeatures.map((f, i) => (
        <Collapse.Panel
          header={
            <Row justify="space-between">
              <span className="text-crossed">{f.title}</span>
              {f.tag}
            </Row>
          }
          key={'lost' + i}
        >
          {f.content}
        </Collapse.Panel>
      ))}

      {filteredList.map((f, i) => (
        <Collapse.Panel
          header={
            <Row justify="space-between">
              {f.title}
              {f.tag}
            </Row>
          }
          key={i}
        >
          {f.content}
        </Collapse.Panel>
      ))}
    </Collapse>
  );
};

Features.propTypes = {
  planType: PropTypes.string,
  currentUserPlan: PropTypes.object,
  newPlan: PropTypes.object,
  isDowngrade: PropTypes.bool,
  isUpgrade: PropTypes.bool,
};

export default Features;
